module.exports = __webpack_public_path__ + "static/media/21.7dc61a31.jpg";